export default "__VITE_ASSET__DkWkBWoH__"